module.exports = __webpack_public_path__ + "media/images/product-image-placeholder-92a62477a3013978f740919af73b253e.png";